<div style="margin: 10px;">
    <h3>You are going to settle amount : <b>{{totalAmountToBeSettled()}}$</b></h3>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-md-12">
            <mat-form-field>
                <mat-label>Transaction Number</mat-label>
                <input matInput [(ngModel)]="settlementFeed.transactionNumber">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-md-12">
            <mat-form-field class="example-full-width">
                <mat-label>Settled On Date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="settlementFeed.settledOn" (click)="picker.open()">
                <mat-datepicker #picker></mat-datepicker>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
            <div style="border: .5px solid red; padding: 3px; margin: 2px; ">
                <a href="javascript:void(0)" (click)="file.click()">
                    <i class="fa fa-upload"></i> click to upload Payment Proof
                </a>
                <input type="file" #file (change)="onUpdateFile($event)" style="display:none" />
            </div>
            <span *ngIf="fileToUpload !== undefined">{{fileToUpload.name}}</span>
        </div>
    </div>
    <div class="confirmBtn">
        <button (click)="onUpdate()" style="margin-bottom: 5px; border-radius: 0px; width: 100%;">Update</button>
        <button (click)="onCancel()"  style="margin-bottom: 5px; border-radius: 0px; width: 100%;">Cancel</button>
    </div>
</div>